/**
 * Cable Size Calculator - Data & constants
 * BS 7671 reference values
 */

// Volt Drop options
export const VOLT_DROP_OPTIONS = [
  { id: '', label: 'Select', value: null },
  { id: '3', label: '3% - Lighting', value: 3 },
  { id: '5', label: '5% - Power', value: 5 },
  { id: 'other', label: 'Other', value: null },
];

// Earthing Type
export const EARTHING_TYPE_OPTIONS = [
  { id: '', label: 'Select', value: '' },
  { id: 'TN-C-S', label: 'TN-C-S', value: 'TN-C-S' },
  { id: 'TN-S', label: 'TN-S', value: 'TN-S' },
  { id: 'TT-NO-RCD', label: 'TT - No RCD', value: 'TT-NO-RCD' },
  { id: 'TT-30MA', label: 'TT - 30mA RCD', value: 'TT-30MA' },
  { id: 'TT-100MA', label: 'TT - 100mA RCD', value: 'TT-100MA' },
  { id: 'TT-300MA', label: 'TT - 300mA RCD', value: 'TT-300MA' },
];

// Ze by enquiry (for info modal)
export const ZE_BY_ENQUIRY = {
  TT: 20,
  'TN-S': 0.8,
  'TN-C-S': 0.35,
};

// Protective Device types
export const PROTECTIVE_DEVICE_OPTIONS = [
  { id: '', label: 'Select' },
  { id: '60898-B', label: 'BS EN 60898 MCB TYPE B' },
  { id: '60898-C', label: 'BS EN 60898 MCB TYPE C' },
  { id: '60898-D', label: 'BS EN 60898 MCB TYPE D' },
  { id: '60898-1', label: 'BS EN 60898 MCB TYPE 1' },
  { id: '60898-2', label: 'BS EN 60898 MCB TYPE 2' },
  { id: '60898-3', label: 'BS EN 60898 MCB TYPE 3' },
  { id: '61009-B', label: 'BS EN 61009 RCBO TYPE B' },
  { id: '61009-C', label: 'BS EN 61009 RCBO TYPE C' },
  { id: '61009-D', label: 'BS EN 61009 RCBO TYPE D' },
  { id: '3871-B', label: 'BS 3871 MCB TYPE B' },
  { id: '3871-C', label: 'BS 3871 MCB TYPE C' },
  { id: '3871-D', label: 'BS 3871 MCB TYPE D' },
  { id: '3871-1', label: 'BS 3871 MCB TYPE 1' },
  { id: '3871-2', label: 'BS 3871 MCB TYPE 2' },
  { id: '3871-3', label: 'BS 3871 MCB TYPE 3' },
  { id: '3871-4', label: 'BS 3871 MCB TYPE 4' },
  { id: '60947-2-B', label: 'BS EN 60947-2 MCB TYPE B' },
  { id: '60947-2-C', label: 'BS EN 60947-2 MCB TYPE C' },
  { id: '60947-2-D', label: 'BS EN 60947-2 MCB TYPE D' },
  { id: '60947-2-ACB', label: 'BS EN 60947-2 ACB' },
  { id: '60947-2-MCCB', label: 'BS EN 60947-2 MCCB' },
  { id: '88-gG', label: 'BS 88-2.2 & 88-6 FUSE gG' },
  { id: '88-mG', label: 'BS 88-2.2 & 88-6 FUSE mG' },
  { id: '88-aM', label: 'BS 88-2.2 & 88-6 FUSE aM' },
  { id: '88-SYSTEM-C', label: 'BS 88-3 FUSE SYSTEM C' },
  { id: '3036', label: 'BS 3036 SEMI ENCLOSED FUSE' },
  { id: '1361-1', label: 'BS 1361 FUSE HBC TYPE 1' },
  { id: '1361-2', label: 'BS 1361 FUSE HBC TYPE 2' },
];

// Device Rating (In) - Amps
export const DEVICE_RATING_OPTIONS = [
  { id: '', label: 'Select', value: null },
  { id: '1', label: '1', value: 1 },
  { id: '2', label: '2', value: 2 },
  { id: '3', label: '3', value: 3 },
  { id: '4', label: '4', value: 4 },
  { id: '5', label: '5', value: 5 },
  { id: '6', label: '6', value: 6 },
  { id: '10', label: '10', value: 10 },
  { id: '13', label: '13', value: 13 },
  { id: '15', label: '15', value: 15 },
  { id: '16', label: '16', value: 16 },
  { id: '20', label: '20', value: 20 },
  { id: '25', label: '25', value: 25 },
  { id: '30', label: '30', value: 30 },
  { id: '32', label: '32', value: 32 },
  { id: '40', label: '40', value: 40 },
  { id: '45', label: '45', value: 45 },
  { id: '50', label: '50', value: 50 },
  { id: '60', label: '60', value: 60 },
  { id: '63', label: '63', value: 63 },
  { id: '80', label: '80', value: 80 },
  { id: '100', label: '100', value: 100 },
  { id: '125', label: '125', value: 125 },
  { id: '160', label: '160', value: 160 },
  { id: '200', label: '200', value: 200 },
  { id: '250', label: '250', value: 250 },
  { id: '315', label: '315', value: 315 },
  { id: '355', label: '355', value: 355 },
  { id: '400', label: '400', value: 400 },
  { id: '450', label: '450', value: 450 },
  { id: '500', label: '500', value: 500 },
  { id: '560', label: '560', value: 560 },
  { id: '630', label: '630', value: 630 },
  { id: '670', label: '670', value: 670 },
  { id: '710', label: '710', value: 710 },
  { id: '800', label: '800', value: 800 },
];

// Cable Type
export const CABLE_TYPE_OPTIONS = [
  { id: '', label: 'Select' },
  { id: 'cu-flat-twin', label: 'Cu - Flat Twin & Earth' },
  { id: 'cu-swa-70', label: 'Cu - SWA Multicore 70°C' },
  { id: 'cu-swa-90', label: 'Cu - SWA Multicore 90°C' },
  { id: 'cu-single-70', label: 'Cu - Single-core (singles) 70°C' },
  { id: 'cu-single-90', label: 'Cu - Single-core 90°C thermosetting insulated cables, non-armoured, with or without a sheath' },
  { id: 'h07rn-f', label: 'H07RN-F Multicore 60°C (Table 4F1A)' },
];

// Disconnection Time
export const DISCONNECTION_TIME_OPTIONS = [
  { id: '', label: 'Select', value: null },
  { id: '0.2', label: '0.2 seconds', value: 0.2 },
  { id: '0.4', label: '0.4 seconds', value: 0.4 },
  { id: '5', label: '5 seconds', value: 5 },
];

// Installation Method
export const INSTALLATION_METHOD_OPTIONS = [
  { id: '', label: 'Select' },
  { id: 'c-clipped-1', label: 'C Clipped Direct 1 Phase' },
  { id: 'c-clipped-3', label: 'C Clipped Direct 3 Phase' },
  { id: 'e-free-1', label: 'E Free Air or Tray 1 Phase' },
  { id: 'e-free-3', label: 'E Free Air or Tray 3 Phase' },
  { id: 'd-duct-1', label: 'D Duct or Ground 1 Phase' },
  { id: 'd-duct-3', label: 'D Duct or Ground 3 Phase' },
];

// Ambient Temperature (Ca)
export const AMBIENT_TEMP_OPTIONS = [
  { id: '', label: 'Select', value: null },
  { id: '25', label: '25 °C', value: 25 },
  { id: '30', label: '30 °C (Normal)', value: 30 },
  { id: '35', label: '35 °C', value: 35 },
  { id: '40', label: '40 °C', value: 40 },
  { id: '45', label: '45 °C', value: 45 },
  { id: '50', label: '50 °C', value: 50 },
  { id: '55', label: '55 °C', value: 55 },
  { id: '60', label: '60 °C', value: 60 },
];

// Grouping (Cg) - number of cables
export const GROUPING_OPTIONS = [
  { id: '', label: 'Select', value: null },
  { id: '1', label: '1 Cable', value: 1 },
  { id: '2', label: '2 Cables', value: 2 },
  { id: '3', label: '3 Cables', value: 3 },
  { id: '4', label: '4 Cables', value: 4 },
  { id: '5', label: '5 Cables', value: 5 },
  { id: '6', label: '6 Cables', value: 6 },
  { id: '7', label: '7 Cables', value: 7 },
  { id: '8', label: '8 Cables', value: 8 },
  { id: '9', label: '9 Cables', value: 9 },
  { id: '12', label: '12 Cables', value: 12 },
  { id: '16', label: '16 Cables', value: 16 },
];

// Thermal Insulation (Ci) - mm
export const THERMAL_INSULATION_OPTIONS = [
  { id: '', label: 'Select', value: null },
  { id: '0', label: '0 mm', value: 0 },
  { id: '50', label: '50 mm', value: 50 },
  { id: '100', label: '100 mm', value: 100 },
  { id: '200', label: '200 mm', value: 200 },
  { id: '400', label: '≥ 400 mm', value: 400 },
];
